import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import IconMove from './icon-move.svg'

const TwButton = tw.div`
  flex
  gap-4
  group
  h-32
  items-center
`

const TwIconMove = tw.div`
  flex
  group-hover:text-on-color
  text-obscure-constant-old
`

const TwLabel = tw.div`
  group-hover:text-on-color 
  text-14
  text-menu-text-old
`

export const SelectMultipleTasksButton = () => {
  return (
    <TwButton>
      <TwIconMove>
        <IconMove />
      </TwIconMove>
      <TwLabel>{Lang.msg.multiActionsWithTasks.selectMultipleTasks}</TwLabel>
    </TwButton>
  )
}
